// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__29U5r","messages":"Chat_messages__3o4up","dateDivider":"Chat_dateDivider__1RbDv"};